<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <div class="d-flex align-items-center mr-3" style="gap: 10px;">
              <form [formGroup]="filterForm" class="d-flex gap-3 items-center" style="gap: 10px;" >
                <div class="d-flex flex-column">
                  <label for="status">Filter by</label>
                  <select name="status" id="status" formControlName="status" class="form-control">
                    <option *ngFor="let f of filterZoneBy" [value]="f.value">{{f.name}}</option>
                  </select>
                </div>
                <!-- <div class="align-self-end">
                  <button class="btn btn-primary" [disabled]="filterForm.invalid" type="submit">Filter</button>
                </div> -->
              </form>
            </div>

            <!--<h2>Manage Super Agents</h2>-->
            <div class="float-right">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="openDialog('zoneModal', 'create')">
                <i class="fa fa-plus"></i> &nbsp;<span>Create Zone</span></button>
            </div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="showData">
              <table id="all-state-zones" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>S/N</th>
                  <th>State</th>
                  <th>Zone Name</th>
                  <th>Category</th>
                  <th>Bank Account Number</th>
                  <th>Bank Account Name</th>
                  <th>Bank Name</th>
                  <th>Action</th>
                  <th>Verified</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>S/N</th>
                  <th>State</th>
                  <th>Zone Name</th>
                  <th>Category</th>
                  <th>Bank Account Number</th>
                  <th>Bank Account Name</th>
                  <th>Bank Name</th>
                  <th>Action</th>
                  <th>Verified</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let zone of zones;let i = index;">
                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>
                  <td>{{ zone?.state.name }}</td>
                  <td>{{ zone?.name }}</td>
                  <td>{{ zone?.category?.name | titlecase }}</td>
                  <td>{{ zone?.settlement_account_number ?? '--' }}</td>
                  <td>{{ zone?.settlement_account_name ?? '--'  }}</td>
                  <td>{{ zone?.settlement_bankname ?? '--' }}</td>
                  <td>
                    <div>
                      <span role="button" data-balloon="Edit Zone" data-balloon-pos="up" (click)="triggerEdit(zone)" class="btn btn-sm btn-primary">
                        <i class="fa fa-edit"></i>
                      </span>&nbsp;&nbsp;
                     <!-- <span role="button" data-balloon="Delete Zone" data-balloon-pos="up" (click)="deleteZone(zone)">
                        <i class="fa fa-trash text-danger"></i>
                      </span>-->

                      <button
                        type="button"
                        [disabled]="disabled && currentZoneId === zone.id"
                        [attr.data-balloon]="zone.status === 'Active' ? 'Disable Zone' : 'Enable Zone'"
                        data-balloon-pos="up"
                        [ngClass]="{
                          'btn-danger': zone.status === 'Active',
                          'btn-success': zone.status !== 'Active'
                        }"
                        (click)="toggleZoneStatus(zone)"
                        class="btn btn-sm"
                      >
                        {{ zone.status === 'Active' ? 'Disable Zone' : 'Enable Zone' }}
                      </button>

                      
                    </div>
                  </td>
                  <td>{{ zone?.settlement_verified_at ?? '--' }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Create Zone Modal -->
<app-modal [modalId]="'zoneModal'" [modalTitle]="modal.title" >
      <form class="form-auth-small" [formGroup]="zoneForm" (ngSubmit)="saveZone()">
        <div class="modal-body">
          <div class="form-group">
            <label for="selectState" id="selectState" class="control-label">Select State</label>
            <select name="state" id="state" formControlName="state_id" class="form-control">
              <option value="">Select state zone</option>
              <option *ngFor="let s of allStates" [value]="s.id">{{s.name}}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="zone_name" id="zone_name" class="control-label">Category</label>
            <select name="cat" id="cat" formControlName="category_id" class="form-control" >
              <option value="">Select category</option>
              <option *ngFor="let c of categories" [value]="c.id">{{c.name}}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="zone_name" class="control-label">Zone Name</label>
            <input type="text" class="form-control" placeholder="Zone Name"
                   formControlName="name"
                   id="zone_name"
            >
          </div>
          <div class="row g-3">
            <div class="col-md-6">
              <div class="form-group">
                <label for="bank" class="form-label">Bank Name</label>
                <select
                  name="bank"
                  id="bank"
                  formControlName="settlement_bank_code"
                  class="form-control"
                >
                  <option value="">Select Bank</option>
                  <option *ngFor="let b of banks" [value]="b.bank_code">
                    {{ b.bank_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group position-relative">
                <label for="bank_number" class="form-label">Bank Account Number</label>
                <input
                  type="text"
                  id="bank_number"
                  class="form-control"
                  placeholder="Enter Bank Number"
                  formControlName="settlement_account_number"
                  [maxLength]="10"
                >
                <span *ngIf="loadingAccountName" class="position-absolute" style="right: 10px; top: 40px;">&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
                <small class="text-danger" *ngIf="validateAccountNumber()" >Account Number must be 10 digit</small>
                <strong *ngIf="accountName.length > 0">{{accountName}}</strong>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" *ngIf="!loaders.saving" [disabled]="disableZoneArea()"  class="btn btn-primary">{{modal.btnText}}</button>
          <span *ngIf="loaders.saving" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
          <button type="button" class="btn btn-danger" data-dismiss="modal">CLOSE</button>
        </div>
      </form>
</app-modal>
